import { render, staticRenderFns } from "./maintenanceCosts .vue?vue&type=template&id=2a3522aa&scoped=true&"
import script from "./maintenanceCosts .vue?vue&type=script&lang=js&"
export * from "./maintenanceCosts .vue?vue&type=script&lang=js&"
import style0 from "./maintenanceCosts .vue?vue&type=style&index=0&id=2a3522aa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3522aa",
  null
  
)

export default component.exports